<template>
  <div id="aclist" class="relativeItem">
    <!--头部-->
    <div class="head relativeItem">
      <img class="noevents-img" src="../../assets/aclist/aclist(2).png" />
      <img class="text centerX absoluteItem noevents-img" src="../../assets/aclist/aclists(12).png" />
      <img class="deng dleft absoluteItem noevents-img" src="../../assets/aclist/aclist(13).png" />
      <img class="deng dright absoluteItem noevents-img" src="../../assets/aclist/aclist(14).png" />
    </div>

    <!--榜单位置-->
    <div class="mainshell relativeItem">

      <img class="imgBlock titleimg" src="../../assets/aclist/naclist(14).png" />

      <div class="list-title flex-box relativeItem">
        <p class="mingci">排名</p>
        <p class="headimg">头像</p>
        <p class="name">昵称</p>
        <p class="number absoluteItem centerY">魅力值</p>
      </div>
      <div class="main relativeItem" id="main">
        <div class="not-none" id="u">
          <!--榜单-->
          <ul id="u1" class="lists" v-show="list.length > 0">
            <li class="flex-box relativeItem" v-for="(n, index) in list" :key="index">
              <span class="mingci" v-show="index == 0">
                <img src="../../assets/aclist/aclists(6).png" />
              </span>
              <span class="mingci" v-show="index == 1">
                <img src="../../assets/aclist/aclists(8).png" />
              </span>
              <span class="mingci" v-show="index == 2">
                <img src="../../assets/aclist/aclists(7).png" />
              </span>
              <span class="mingci" v-show="index > 2">{{ index + 1 }}</span>
              <p class="headimg">
                <img class="noevents-img" :src="n.avatar" />
              </p>
              <p class="name apostrophe">{{ n.nickname }}</p>
              <span class="number absoluteItem centerY">{{ n.cost }}</span>
            </li>
          </ul>
        </div>
        <ul id="u2" class="lists"></ul>

        <!--空数据时-->
        <p class="none absoluteItem centerX" v-show="list.length === 0">暂无上榜</p>
      </div>
    </div>
  </div>
</template>















<script>

export default {
  name: "aclist0723",
  data() {
    return {
      activeGift: 0,
      see_shi_liang: 1, //0限时 1限量
      see_type: 0, //0主播 1富豪
      gifts: [[], []], //限时和限量礼物
      list:[],//列表数据
      show_gifts: [], //展示的礼物
      show_data: [], //展示的数据
      roll_obj: null //滚动计时器
    };
  },
  methods: {
    /**获取对应礼物的用户列表 */
    getlist() {
      let _this = this;
      this.$jsonp(_this.$apis("yue_bang_list"), {}, res => {
        for (const n of res.data.data.result.list) {
          n.cost = _this.$tool.million(n.cost);
        }
        _this.list = res.data.data.result.list;
      });
    },


  },
  mounted: function() {
    this.$tool.setTitle("月度排行榜");
    this.getlist();
  },
};
</script>



















<style scoped>
#aclist {
  background: #111216;
  padding-bottom: 60px;
  overflow-x: hidden;
}
img {
  display: block;
}
/**头部 */
.head {
  overflow: hidden;
}
.head .text {
  width: 88%;
  top: 0;
  z-index: 3;
  animation: aclistText 1s ease-in-out alternate infinite;
}
.deng {
  width: 100%;
  left: 0;
  top: 0;
}
.dleft {
  top: 0;
  z-index: 1;
  transform-origin: left top;
  animation: aclistDright 1.2s ease-in-out alternate infinite;
}
.dright {
  z-index: 2;
  transform-origin: right top;
  animation: aclistDright 1.2s ease-in-out alternate infinite;
}
.button-little {
  width: 79%;
  top: -20px;
  justify-content: space-between;
}
.button-little img {
  width: 135px;
  height: 41px;
}

/**礼物区 */
.hua {
  margin-top: 11%;
  background: url("../../assets/aclist/nuemm.jpg") no-repeat left center;
  background-size: 100%;
}
.hua ul {
  padding: 0 12%;
  min-height: 198px;
}
.hua ul li {
  width: 26.5%;
  float: left;
  margin-right: 10.25%;
  margin-bottom: 24px;
  overflow: hidden;
}
.hua ul .gift-img {
  max-width: 85%;
}
.hua ul li:nth-child(3n) {
  margin-right: 0;
}
.hua .swiper-slide-active .imgshell {
  background: url("../../assets/aclist/aclist(9).png") no-repeat left top;
  background-size: 100% 100%;
  transform: scale(1.3);
}
.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: 51%;
  width: 13px;
  height: 19px;
  margin-top: -22px;
  z-index: 10;
  cursor: pointer;
  background-size: 13px 19px;
  background-position: center;
  background-repeat: no-repeat;
}
.swiper-button-next {
  background-image: url("../../assets/aclist/aclist(12).png");
  right: 4%;
  left: auto;
  transform: translateY(50%);
}
.swiper-button-prev {
  background-image: url("../../assets/aclist/aclist(12).png");
  left: 4%;
  right: auto;
  transform: rotateZ(180deg) translateY(-50%);
}

/**列表切换按钮 */
.button-big {
  overflow: hidden;
  width: 78%;
  margin: 0 auto;
  margin-top: 12%;
  margin-bottom: 29px;
  background: #111215;
}
.button-big img {
  width: 50%;
  float: left;
}

/**榜单 */
.mainshell {
  position: relative;
  background: url("../../assets/aclist/naclist(14).jpg") no-repeat left top,
    url("../../assets/aclist/naclist.jpg") no-repeat left bottom,
    url("../../assets/aclist/aclist(11).png") repeat left center;
  background-size: 100%;
  padding: 5% 0;
  padding-bottom: 10%;
}
.main {
  height: 500px;
  /* max-height: 1300px; */
  overflow-y: scroll;
}
.none {
  font-size: 16px;
  color: #fff4c4;
  top: 50%;
}

/**普通榜单 */
.list-title {
  color: #767368;
  width: 88%;
  margin: 0 auto;
  font-size: 12px;
  margin-top: 30px;
  height: 40px;
  line-height: 40px;
  background: url("../../assets/aclist/naclist(15).png") no-repeat left top;
  background-size: 100% 100%;
}
.list-title .mingci {
  width: 17%;
  text-align: center;
}
.list-title .headimg {
  width: 50px;
  margin-right: 4%;
  text-align: center;
}
.list-title .number {
  right: 4%;
}

.lists {
  width: 88%;
  margin: 0 auto;
}
.lists li {
  margin: 0 auto;
  padding: 4% 0;
  align-items: center;
  color: #fff4c4;
  background: url("../../assets/aclist/naclist(17).png") no-repeat left top;
  background-size: 100% 100%;
}
.lists li:nth-child(2n) {
  background: url("../../assets/aclist/naclist(18).png") no-repeat left top;
  background-size: 100% 100%;
}
.lists .mingci {
  display: inline-block;
  font-size: 15px;
  width: 17%;
  text-align: center;
}
.lists .mingci img {
  width: 34px;
  margin: 0 auto;
}
.lists .headimg {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 1px solid #d7c892;
  padding: 3px;
  margin-right: 4%;
}
.lists .headimg img {
  height: 100%;
  border-radius: 50%;
  /* border: 1px solid #e5d59a; */
}
.lists .name {
  font-size: 13px;
  max-width: 40%;
}
.lists .number {
  font-size: 15px;
  right: 4%;
}

/**活动规则相关 */
.titleimg {
  width: 80%;
  margin: 0 auto;
}
.rules {
  width: 100%;
  background: url("../../assets/aclist/nac(1).jpg") no-repeat left bottom,
    url("../../assets/aclist/nac(2).jpg") no-repeat left top,
    url("../../assets/aclist/nac(3).jpg") no-repeat top left;
  background-size: 100%, 100%, 100% 100%;
  min-height: 320px;
  padding-top: 16%;
}
.rules img {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 30px;
}
.rules p {
  font-size: 11px;
  color: #fff4c4;
  padding: 0 10%;
  margin-bottom: 13px;
}

.litip {
  text-align: justify;
  line-height: 20px;
  font-weight: bold;
  color: white;
}
.more {
  text-align: center !important;
  margin-top: 15px;
  font-size: 15px !important;
}
.wcolor {
  color: white !important;
}
</style>

<style>
/* 全局样式 */
/**banner区 */
#pagination {
  bottom: -20px;
}
.banner-bullets {
  width: 14px;
  height: 5px;
  display: inline-block;
  border-radius: 3rem;
  background: #535456;
  margin-right: 6px;
}
.banner-bullets:last-child {
  margin: 0;
}
.swiper-container {
  overflow: visible !important;
}
.banner-bullets-active {
  background: #79693d;
}
</style>
